var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("LfHeaderTitleComponent", {
        staticClass: "header-title",
        attrs: { title: _vm.texts.headerTitle },
      }),
      _vm.totals && _vm.totals.length
        ? _c("LfTotalsComponent", { attrs: { items: _vm.totals } })
        : _vm._e(),
      _vm.renderGrid && !_vm.showSpinnerLayer
        ? _c("GridTable", {
            ref: "grid",
            attrs: {
              itemsData: _vm.isPortalUser ? _vm.listItems : _vm.serverSideData,
              gridConfiguration: _vm.listConfig,
              listName: _vm.listName,
              toolbarOptions: _vm.toolbarOptionsCustom,
              contextMenuItems: _vm.invoiceContextMenuItems,
              context: _vm.context,
              archivedFilter: _vm.archivedSelectedOption,
              disabledGridCellClicked: _vm.getDisableGridProperty,
              activeOnClickCell: _vm.selectedOnlyOneInvoice,
              checkboxSelectColumn: _vm.showCheckboxSelectColumn,
              showFirstColumn: _vm.showCheckboxSelectColumn,
              frozenColumns: _vm.isPortalUser ? 0 : 2,
              commandClick: _vm.onCommandClick,
              excelExportedFileName: _vm.fileName,
              useServerPagination: _vm.useServerPagination,
              usePersistSelection: _vm.usePersistSelection,
              itemsDataExport: _vm.serverSideExportData,
            },
            on: {
              contextMenuClicked: _vm.onContextMenuClicked,
              contextMenuBeforeOpen: _vm.onContextMenuBeforeOpen,
              toolbarClicked: _vm.onToolbarClicked,
              selectedRecords: _vm.onSelectedRecords,
              customToolbarContextMenuClick:
                _vm.onCustomToolbarContextMenuClick,
              gridActionChange: _vm.gridActionChange,
              gridExportData: _vm.gridExportData,
              cellClicked: _vm.onCellClicked,
            },
          })
        : _vm._e(),
      _vm.renderPrintOrSaveInvoicesDialog
        ? _c("PrintOrSaveInvoicesDialog", {
            attrs: {
              showDialog: _vm.showTemplateDialog,
              idEntityType: _vm.idEntityType,
            },
            on: {
              closePrintOrSaveInvoiceDialog: _vm.closeTemplateDialog,
              generateTemplateDialog: _vm.generateTemplateDialog,
            },
          })
        : _vm._e(),
      _vm.renderTemplateSelectorComponent
        ? _c("TemplateSelectorComponent", {
            attrs: {
              showDialog: _vm.showTemplateDialog,
              idEntityType: _vm.idEntityType,
            },
            on: {
              closeTemplateDialog: _vm.closeTemplateDialog,
              generateTemplateDialog: _vm.generateTemplateDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }